import React, { createContext, useContext } from 'react';

/** Per-request signal that this render is an MCP preview: forces the guest-site SSR path on regardless of iframe/flags. See MCP_PREVIEW.md#hydration-parity. */
const McpPreviewForceSsrContext = createContext<boolean>(false);

export const McpPreviewForceSsrProvider: React.FC<{ forceSsr?: boolean; children: React.ReactNode }> = ({ forceSsr = false, children }) => (
  <McpPreviewForceSsrContext.Provider value={!!forceSsr}>{children}</McpPreviewForceSsrContext.Provider>
);

export const useMcpPreviewForceSsr = (): boolean => useContext(McpPreviewForceSsrContext);
